module.exports = __webpack_public_path__ + "static/media/icon-folder.b9f5b695.svg";